import * as m from "mithril";
import { PaymentTermsModal } from "./TermsModal";
import './SelectedPaymentOption.scss';
import { MessageProvider } from "../../context/AppMessages";
import { MoneyDTO, PaymentMethodDTO, PaymentOptionDTO, PromoCodeVerifiedResponseDTO } from "../../apiclient/ApiDtos";
import PromoCodeApplyBox from "../pay/PromoCodeApplyBox";
import CustomSvgIcon from "../../components/CustomSvgIcon";

let currencyValueFormat = Intl.NumberFormat('en-US', { // 1234.56 => 1,234
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
});

let usdFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
});

let mmkFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'MMK',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
});

interface Attrs {
    messageProvider: MessageProvider,
    hidePromoArea?: boolean,
    selectedPaymentOption: PaymentOptionDTO,
    appliedPromo: PromoCodeVerifiedResponseDTO | null,
    showPromoCodeInvalidError?: boolean,
    showLoading: boolean,
    onApplyPromoCode: (promoCode: string) => void,
    onRemovePromoCode: () => void,
    onSubmitPayment: () => void,
    onCancel: () => void
}
const SpinnerOverlay = {
    view: function () {
        return m("div.spinner-overlay.d-flex.justify-content-center.align-items-center", [
            m("div.spinner-border.text-primary[role='status']", [
            ])
        ]);
    }
};

function SelectedPaymentOption(): m.Component<Attrs> {
    return {
        view(vnode) {
            let { selectedPaymentOption: paymentOption, appliedPromo, showPromoCodeInvalidError } = vnode.attrs;
            console.log("SPO : isInvalidPromo", showPromoCodeInvalidError)
            let paymentMethod: PaymentMethodDTO = paymentOption.paymentMethod;
            let messageProvider = vnode.attrs.messageProvider;


            return m("div.mb-2 position-relative", {
                class: "card"
            }, [

                vnode.attrs.showLoading ? m(SpinnerOverlay) : null,
                m("div", { class: "card-header d-flex justify-content-between _text-center" },
                    m("div", messageProvider.get("title_payment_method")),
                    m("a.ml-1 ms-1", {
                        class: "small font-weight-bold fw-bold",
                        href: "#",
                        onclick: (event) => {
                            event.preventDefault();
                            vnode.attrs.onCancel();
                        }
                    }, messageProvider.get("to_reselect"))
                ),
                m("div.card-body",
                    m("div.row", [
                        m("div.col-6", [
                            m("img.img-logo", {
                                class: "align-middle",
                                src: paymentOption.paymentMethod.logoUrl,
                            })
                        ]),
                        m("div.col-6", [
                            m("div.text-right text-end", paymentMethod.title),
                            m("div.text-muted text-right text-end", m("small", {}, "MMK"))
                        ])
                    ])
                ),

                m("div.card-body", { class: "border-top" },
                    m(PaymentDetailsForm, {
                        hidePromoArea: vnode.attrs.hidePromoArea,
                        paymentOption: paymentOption,
                        appliedPromo: appliedPromo,
                        showPromoCodeInvalidError: showPromoCodeInvalidError,
                        messageProvider: messageProvider,
                        onAddPromoCode: (promoCode: string) => {
                            vnode.attrs.onApplyPromoCode(promoCode)
                        },
                        onRemovePromoCode: () => {
                            vnode.attrs.onRemovePromoCode()
                        },
                        onSubmitPayment: () => {
                            vnode.attrs.onSubmitPayment()
                        },
                    }),
                )
            ])
        }
    }
}

export function PaymentDetailsForm(): m.Component<{
    hidePromoArea?: boolean,
    paymentOption: PaymentOptionDTO,
    showPromoCodeInvalidError?: boolean,
    appliedPromo: PromoCodeVerifiedResponseDTO | null,
    messageProvider: MessageProvider,
    showLoading?: boolean,
    onAddPromoCode: (promoCode: string) => void,
    onRemovePromoCode: () => void,
    onSubmitPayment: () => void
}> {
    let isReadingTerms = false;
    let currentlyAppliedPromo = "";
    return {
        view(vnode) {
            let { paymentOption, appliedPromo, messageProvider, hidePromoArea } = vnode.attrs;

            console.log("Applied Promo: ", appliedPromo)

            let formatMoney = (money: MoneyDTO) => {
                if (money.currency == "MMK") {
                    return mmkFormatter.format(money.amount);
                } else if (money.currency == "USD") {
                    return usdFormatter.format(money.amount);
                }
                return "N/A";
            }

            let netMoneyFormat = (total: MoneyDTO, discount: MoneyDTO) => {
                if (total.currency == "MMK" && discount.currency == "MMK") {
                    return mmkFormatter.format(total.amount - discount.amount);
                } else if (total.currency == "USD" && discount.currency == "USD") {
                    return usdFormatter.format(total.amount - discount.amount);
                }
                return "N/A";
            }

            return m("div", [
                vnode.attrs.showLoading && vnode.attrs.showLoading == true ? m(SpinnerOverlay) : null,
                m("div.row mb-3",
                    m("div.col-6 text-muted", messageProvider.get("subtotal")),
                    m("div.col-6 text-right text-end", mmkFormatter.format(paymentOption.subtotal.amount))
                ),
                m("div.row.mb-3",
                    m("div.col-6 text-muted", messageProvider.get("fees")),
                    m("div.col-6 text-right text-end", currencyValueFormat.format(paymentOption.fees.amount))
                ),


                hidePromoArea && hidePromoArea == true ?
                    null : [
                        appliedPromo != null && appliedPromo.discountAmount != null ?
                            [
                                m("div.d-flex justify-content-between", [
                                    m("div.d-flex align-items-center ",
                                        m("span.text-muted", messageProvider.get("discount")),
                                        m("div.d-flex align-items-center ms-2 ml-2 applied-promo-tag", {
                                            "data-toggle": "tooltip",
                                            "data-placement": "right",
                                            "title": "Remove Promo Code"
                                        },
                                            [
                                                m("div.fw-bold font-weight-bold promo-code-custom-len", appliedPromo.promoCode),
                                                m("span.text-muted ms-2 ml-2 mb-1", {
                                                    role: "button",
                                                    onclick: (event) => {
                                                        event.preventDefault();
                                                        console.log("On Removing Promo Code...")
                                                        vnode.attrs.onRemovePromoCode();
                                                    }
                                                },
                                                    m(CustomSvgIcon, {
                                                        iconType: "cross_remove_fill",
                                                        themeCssClass: "svg-muted svg-small"
                                                    })
                                                )
                                            ]
                                        )
                                    ),
                                    m("div", "( - ) " + currencyValueFormat.format(appliedPromo.discountAmount.amount))
                                ]),
                            ]
                            :
                            m(PromoCodeApplyBox, {
                                messageProvider: messageProvider,
                                appliedPromoCode: currentlyAppliedPromo,
                                isInvalidPromoCode: vnode.attrs.showPromoCodeInvalidError,
                                onAddPromoCode: (promoCode: string) => {
                                    currentlyAppliedPromo = promoCode;
                                    vnode.attrs.onAddPromoCode(promoCode)
                                },
                                onRemovePromoCode: () => {
                                    vnode.attrs.onRemovePromoCode()
                                },
                            }),
                    ],

                m("hr.dotted-line"),
                m("div.row mb-3 fw-bold font-weight-bold text-success",
                    m("div.col-6 text-muted_", messageProvider.get("total")),
                    appliedPromo ?
                        m("div.col-6 text-right text-end", netMoneyFormat(paymentOption.total, appliedPromo.discountAmount)) :
                        m("div.col-6 text-right text-end", formatMoney(paymentOption.total))
                ),

                m("div.mt-4 clickable-area", {
                    onclick: (event) => {
                        event.preventDefault();
                        isReadingTerms = true;
                    }
                },
                    messageProvider.get("agree_to_terms"),

                    m("span.font-weight-bold fw-bold text-primary",
                        messageProvider.get("terms_link")),

                    messageProvider.get("agree_to_terms_end")
                ),
                m("a.mt-2", {
                    class: "btn btn-primary btn-block text-white form-control",
                    href: "#",
                    onclick: (event) => {
                        event.preventDefault();
                        vnode.attrs.onSubmitPayment();
                    }
                }, messageProvider.get("proceed_to_pay")),



                isReadingTerms ?
                    m(PaymentTermsModal, {
                        messageProvider: messageProvider,
                        terms: paymentOption.paymentMethod.terms,
                        onCloseModal: () => {
                            isReadingTerms = false;
                            m.redraw()
                        }
                    })
                    : null

            ])
        }
    }
}


export default SelectedPaymentOption;